<template>
  <modal
    name="add-user-modal"
    :classes="'customModal'"
    :scrollable="true"
    :reset="true"
    :adaptive="false"
    :width="650"
    height="auto"
    @before-open="getData"
    @closed="closeModal()"
  >
    <div class="modalWrapper">
      <div class="content__box">
        <div class="content__box__header">
          <p class="text-white txt--ss opacity--50">Add User/Operator</p>
        </div>
        <div class="content__divider"></div>
        <div class="content__box__body">
          <div class="form-group">
            <label class="txt--xs txt--off-white mb-2"
              >Email Address(es) seperate emails by a space or comma</label
            >
            <!-- <input
              type="email"
              class="textInputField"
              placeholder="Enter email address(es)"
              v-model="email"
            /> -->
              <vue-tags-input
                v-model="emailtags"
                :tags="tags"
                @tags-changed="(newTags) => (tags = newTags)"
                :separators="[' ']"
                placeholder="Enter email address(s)"
              />
          </div>
          <label class="txt--xs txt--off-white mb-2">Role(required)</label>
          <!-- <multiselect
            class="multi-select-input"
            v-model="roles"
            :options="role_options"
            :multiple="false"
            :close-on-select="true"
            group-values="permits"
            group-label="poperty"
            :group-select="true"
            placeholder="Select Role"
            label="name"
          >
            <span slot="noResult">Oops! No permit found</span>
            <template slot="tag"
              ><span class="multiselect__tag">
                <span></span>
                <i
                  aria-hidden="true"
                  tabindex="1"
                  class="multiselect__tag-icon"
                ></i> </span
            ></template>
          </multiselect> -->
          <multiselect v-model="value"  class="multi-select-input" deselect-label="Can't remove this value" track-by="id"  label="name" placeholder="Select Role" :options="options" :searchable="true" :allow-empty="false">
            <template slot="singleLabel" slot-scope="{ option }"> {{ option.name }}</template>
          </multiselect>
            <!-- <multiselect v-model="value" class="multi-select-input"  tag-placeholder="Add this as new tag" placeholder="Search or add a tag" label="name" track-by="id" :options="options" :multiple="false" :taggable="true" @tag="addRoles"></multiselect> -->


          <label class="txt--xs txt--off-white mb-2"
            >Department(required)</label
          >
           <!-- <multiselect v-model="department"  class="multi-select-input" deselect-label="Can't remove this value" track-by="department_id"  label="department_name" placeholder="Select Role" :options="department_options" :searchable="true" :allow-empty="false">
            <template slot="singleLabel" slot-scope="{ department_options }"> {{ department_options.department_name }}</template>
          </multiselect> -->
            <multiselect v-model="department" class="multi-select-input"  tag-placeholder="Add this as new department" placeholder="Select Department" label="department_name" track-by="department_id" :options="department_options" :multiple="false" :taggable="true" @tag="addTag"></multiselect>
            
          

        </div>
      </div>
      <div class="d-flex justify-content-center flex-wrap mt-4">
        <ButtonWithSpinner class="button button--primary button--sm mr-3" @click="addOperator"
        :disabled="create_button.disabled"
        :loading="create_button.loading"
        :success="create_button.success"
        >
          Add</ButtonWithSpinner
        >
        <button
          type="button"
          class="button button--outline button--sm"
          @click="closeModal()"
        >
          Cancel
        </button>
      </div>
      <div class="session__modal__close" @click="closeModal()">
        <i class="fas fa-times"></i>
      </div>
    </div>
  </modal>
</template>
<script>
import "vue-search-select/dist/VueSearchSelect.css";
// import { ModelSelect, ModelListSelect } from "vue-search-select";
import ButtonWithSpinner from "@/components/Button";
import VueTagsInput from "@johmun/vue-tags-input";
import Toggle from "@/components/toggle";
export default {
  name: "AddUser",
  components: {
    // AppToggle: Toggle,
    // ModelListSelect,
    // ModelSelect,
    ButtonWithSpinner,
    VueTagsInput
  },
  data() {
    return {
      emailtags:'',
      tags:[],
      email: '',
      value: null,
      options: [],
      department:null,
      department_options:[],
      unlimited_validaiton: true,
      create_button: {
        disabled: false,
        loading: false,
        success: false,
      },

    };
  },
  computed: {
    filteredItems() {
      return this.autocompleteItems.filter((i) => {
        return i.text.toLowerCase().indexOf(this.emailtags.toLowerCase()) !== -1;
      });
    },
  },
  created() {
    
  },
  methods: {
    getData(){
      //test
      // console.log("hii");
      this.getRoles();
      this.getDepartments();
    },
    reset(){
      this.email= '',
      this.emailtags='',
      this.tags=[],
      this.value= null,
      this.options= [],
      this.department=null,
      this.department_options=[]
      this.create_button.disabled =false;
      this.create_button.loading  =false;
      this.create_button.success =false;     
    },
    closeModal() {
      this.reset();
      this.$modal.hide("add-user-modal");
    },
    addOperator(){
      setTimeout(()=>{

      
      this.email = this.tags
        .filter((val) => val.text)
        .map(({ text }) => text);
      // console.log(this.email);

      if (this.email != "" ) {
        //var nameArr = this.emailInvitation.split(/[ ,]+/);
        this.email = this.email.toString().split(/[,]+/);

        for (var j = 0; j < this.email.length; j++) {
          var emailformat = window.regularExpressions.email.test(
            this.email[j].toString().toLowerCase()
          );

          if (!emailformat) {
            this.$toasted.show("Please enter valid email!", {
              icon: "times-circle",
              className: "error-class",
            });
            return;
          }
        }
      }
      if(this.email == ''){
        this.$toasted.show('Please provide email',{
            icon : 'times-circle',
            className: 'error-class'
        });      
        return false;
      }
      this.create_button.loading = true;
      this.create_button.disabled = true;
      this.create_button.success = false;
      this.axios
        .post(window.hostname + "/api/auth/operator/create", {
          email:this.email,
          role:this.value,
          department:this.department

        }).then((res)=>{
          if(res.data.status){
            this.$emit('update_list');
            this.create_button.disabled = false;
            this.create_button.success = true;
            this.create_button.loading = false;
            this.$toasted.show(res.data.message, {
                icon: "check-circle",
                className: "success-class",
            });
            this.reset();
            this.closeModal();
          }
          else{
            this.create_button.disabled = false;
            this.create_button.success = false;
            this.create_button.loading = false;
            this.$toasted.show(res.data.message,{
                icon : 'times-circle',
                className: 'error-class'
            });             
          }
          // console.log(res);
        })
      // console.log(this.value);
      // console.log(this.email);
      // console.log(this.department);

      },550)
    },
    addTag (newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
      }
      this.department_options.push(tag)
      this.department.push(tag)
    },
    addRoles(newTag){
        const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
      }
      this.options.push(tag)
      this.value.push(tag)

    },
    getRoles(){
      let owner_id = localStorage.getItem('user_id');

      this.axios
        .post(window.hostname + "/api/auth/role/list", {
          owner_id:owner_id,
          status:1,
        }).then((res)=>{
          // console.log(res);
          this.options =res.data.data.role_list;
          // console.log(this.value);
        })
    },
    getDepartments(){
       this.axios
        .post(
          window.hostname + "/api/auth/departments/list",
          {
            commercial: 1,
            status:1,
            page: 1,
          },
        ).then((res)=>{
          this.department_options =res.data.data.department_list;
          // console.log(res);
        })
    }
  },
};
</script>

<style scoped>
.modified-toggle-switch p {
  flex-basis: 50%;
}

.modified-toggle-switch app-toggle {
  flex-basis: 50%;
}
</style>